import script from "./pageHomeSon.vue?vue&type=script&setup=true&lang=js"
export * from "./pageHomeSon.vue?vue&type=script&setup=true&lang=js"

import "./pageHomeSon.vue?vue&type=style&index=0&id=18672998&scoped=true&lang=css"
import "./pageHomeSon.vue?vue&type=style&index=1&id=18672998&lang=scss"
import "./pageHomeSon.vue?vue&type=style&index=2&id=18672998&lang=css"

import exportComponent from "D:\\WORK_At_Home\\kaikbSource\\restaurant-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18672998"]])

export default __exports__